import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable consistent-return */
import { useStripe, useElements, CardNumberElement, CardCvcElement, CardExpiryElement } from "@stripe/react-stripe-js";
import React, { useEffect, useMemo } from "react";
import toastService from "Root/profile/toastService";
import amex from "Images/profile/americanexpress.png";
import visa from "Images/profile/visa.png";
import mastercard from "Images/profile/mastercard.png";
import discover from "Images/profile/discover.png";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { useDispatch } from "react-redux";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { apiAddCard } from "Root/api/apiProfile";
import styles from "./style.module.css";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
export const useOptions = () => {
    const options = useMemo(() => ({
        style: {
            base: {
                color: "#333",
                background: "#fff",
                borderRadius: "4px",
                fontWeight: 500,
                fontFamily: "Halyard Display, sans-serif",
                fontSize: "20px",
                fontSmoothing: "antialiased",
                border: "1px solid #D6D6D6",
                lineHeight: "43px",
                "::placeholder": {
                    color: "#CFD7DF",
                },
                ":-webkit-autofill": {
                    color: "#e39f48",
                },
            },
            invalid: {
                color: "#E25950",
                "::placeholder": {
                    color: "#FFCCA5",
                },
            },
        },
        classes: {
            focus: "focused",
            empty: "empty",
            invalid: "invalid",
        },
        showIcon: true,
    }), []);
    return options;
};
const PaymentMethodBox = ({ setCardsData, goBack, isReactivate, forceSubmit }) => {
    const stripe = useStripe();
    const elements = useElements();
    const options = useOptions();
    // const { setGlobalLoading } = useContext(GeneralContext);
    const isMobile = useScreenWidth() < 768;
    const dispatch = useDispatch();
    const addPaymentMethod = async () => {
        try {
            // //setGlobalLoading(true);
            dispatch(setGlobalLoading(true));
            if (!stripe || !elements)
                return null;
            if (elements.getElement(CardNumberElement)) {
                const tokenPayload = await stripe.createToken(elements.getElement(CardNumberElement));
                if (tokenPayload.error) {
                    toastService.errorMessage(tokenPayload.error.message || "");
                    return;
                }
                const stripeToken = tokenPayload.token ? tokenPayload.token.id : "";
                const cardData = await apiAddCard({ stripeToken });
                setCardsData(cardData.card_data);
                goBack();
                toastService.successMessage("Success: Card Added");
            }
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
        finally {
            // setGlobalLoading(false);
            dispatch(setGlobalLoading(false));
        }
    };
    const onSubmitForm = (e) => {
        e.preventDefault();
        addPaymentMethod();
    };
    useEffect(() => {
        if (forceSubmit) {
            addPaymentMethod();
        }
    }, [forceSubmit]);
    return (_jsxs("form", { onSubmit: onSubmitForm, className: `${!isReactivate ? styles.payment_method_box : styles.reactivation_inputs_wrapper}`, children: [_jsxs("div", { children: [_jsx("span", { className: "input-form-control__label", children: "Card number" }), _jsx(CardNumberElement, { options: options, className: "input-wrapper" }), _jsxs("div", { className: styles.cardcontain, children: [_jsx("img", { src: amex, alt: "American Express" }), _jsx("img", { src: visa, alt: "Visa" }), _jsx("img", { src: mastercard, alt: "Mastercard" }), _jsx("img", { src: discover, alt: "Discover" })] })] }), _jsxs("div", { className: styles.payment_info, children: [_jsxs("div", { className: styles.payment_info_item, children: [_jsx("span", { className: "input-form-control__label", children: "Expiration date" }), _jsx(CardExpiryElement, { options: options, className: "input-wrapper" })] }), _jsxs("div", { className: styles.payment_info_item, children: [_jsx("span", { className: "input-form-control__label", children: "CVC" }), _jsx(CardCvcElement, { options: options, className: "input-wrapper" })] })] }), !(isReactivate && isMobile) && (_jsx(RoundedGainfulButton, { onClick: () => { }, extraClassName: styles.add_payment, type: "submit", label: "add payment method" }))] }));
};
export default PaymentMethodBox;
